import React from 'react';

const UpdatePasswordPage = () => {
  return (
    <div>
      <h1>UpdatePassword</h1>
    </div>
  );
};

export default UpdatePasswordPage;
